// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-file.hide {
  position: absolute;
  top: 0;
  opacity: 0;
}

.upload-file {
  position: relative;
  width: 100%;
}
.upload-file .hidden {
  display: none;
}
.upload-file.fixed-aspect-ratio {
  aspect-ratio: 16/9;
}
.upload-file.fixed-aspect-ratio .media-preview,
.upload-file.fixed-aspect-ratio video {
  height: 100%;
}
.upload-file .drop-zone {
  display: inline-block;
  margin: auto;
  width: 100%;
  height: 100%;
  min-height: 200px;
  vertical-align: middle;
  background: #eee;
  color: #333;
  position: relative;
  border: 1px solid var(--motes-gray);
  box-sizing: border-box;
  overflow: hidden;
}
.upload-file .drop-zone.file-not-empty {
  min-height: 100px;
}
.upload-file .drop-zone.show-placeholder {
  background: var(--upload-background-gradient);
}
.upload-file .drop-zone.hovering {
  border: 1px solid var(--motes-highlight-color-dark);
  box-sizing: border-box;
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.3215686275);
}
.upload-file .drop-zone.uploaded {
  border: 1px solid rgb(230, 230, 230) !important;
}
.upload-file .drop-zone a {
  color: var(--motes-blue-link);
}
.upload-file .drop-zone a:hover {
  text-decoration: underline;
  transition: none;
}
.upload-file .drop-zone-inner {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
}
.upload-file .drop-zone-inner .file-input-button {
  pointer-events: initial;
}
.upload-file .drop-zone-inner .file-input-button.inactive {
  pointer-events: none;
}
.upload-file .file-not-empty {
  color: white;
}
.upload-file .drop-zone-inner-hidden {
  opacity: 0;
}
.upload-file video,
.upload-file img,
.upload-file audio {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: auto;
  margin-bottom: 0;
  border-radius: 10px;
}
.upload-file .media-preview img {
  opacity: 0;
  height: 100%;
}
.upload-file .media-preview .image-loaded {
  transition: opacity 400ms;
  opacity: 1;
}
.upload-file .media-preview .loading-image {
  position: absolute;
  top: 0;
}
.upload-file .media-preview .loading-image img {
  opacity: 1;
}
.upload-file audio {
  position: absolute;
  width: 90%;
  top: 0;
  max-width: 400px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.upload-file .drop-zone.hovering {
  transform: scale(1.2);
  transition: 250ms;
  opacity: 0.7;
}
.upload-file .placeholder-image {
  position: relative;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.upload-file .placeholder-image img {
  position: relative;
  width: auto;
  margin: auto;
  max-height: 100%;
  margin-top: 6px;
}
.upload-file .drop-zone.hovering .placeholder-image {
  transform: scale(1.2);
  transition: 250ms;
  opacity: 0.6;
}
.upload-file .upload-progress {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  opacity: 0;
  transition: 1200ms;
  pointer-events: none;
}
.upload-file .progress-overlay {
  position: absolute;
  width: 100%;
  border-radius: inherit;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: 500ms;
  height: 0%;
}
.upload-file .media-icon .svg-icon:hover {
  cursor: pointer;
  transition: none;
  color: white;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.8));
}
.upload-file .play-icon-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-file .play-icon-wrapper .play-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  box-sizing: border-box;
  padding: 0px;
  border-radius: 100%;
  background: var(--upload-background-gradient);
  box-shadow: var(--shadow-elevation-low);
}
.upload-file .play-icon-wrapper .svg-icon {
  cursor: pointer;
  font-size: 50px;
  line-height: 50px;
  transition: font-size 200ms;
}
.upload-file .play-icon-wrapper .svg-icon:hover {
  font-size: 55px;
}
.upload-file .play-icon-wrapper .svg-icon svg {
  display: block;
  margin: auto;
}
.upload-file .drop-zone-error {
  color: #dd4b39;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  box-sizing: border-box;
  transition: 200ms;
  opacity: 0;
  pointer-events: none;
}
.upload-file .drop-zone-inner.shown,
.upload-file .upload-progress.shown {
  opacity: 1;
  transition: 1000ms;
}
.upload-file .audio-background-clip {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
}
.upload-file .audio-background-show {
  transition: 1000ms ease-in;
  opacity: 1;
}
.upload-file .audio-background {
  top: -2px;
  left: -2px;
  object-fit: cover;
  transform: scale(1.1);
  filter: blur(6px);
}
.upload-file .external-video {
  height: 100%;
}
.upload-file .placeholder-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.upload-file .placeholder-container .allowed-types {
  display: flex;
  height: 50%;
  width: 100%;
  margin-bottom: 20px;
  justify-content: space-evenly;
  opacity: 0;
  filter: blur(6px);
}
.upload-file .placeholder-container .allowed-types.fade-in {
  opacity: 1;
  filter: blur(0);
  transition: 0.3s;
}
.upload-file .placeholder-container .allowed-types img {
  height: 100%;
  width: -moz-fit-content;
  width: fit-content;
  object-fit: contain;
  margin: 0;
}
.upload-file .placeholder-container .drag-drop-text p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/upload-file/upload-file.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EAEA,WAAA;AAAJ;AAEI;EACI,aAAA;AAAR;AAGI;EACI,kBAAA;AADR;AAGQ;;EAEI,YAAA;AADZ;AAKI;EACI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;AAHR;AAMI;EACI,iBAAA;AAJR;AAOI;EACI,6CAAA;AALR;AAQI;EACI,mDAAA;EACA,sBAAA;EACA,uDAAA;AANR;AASI;EACI,+CAAA;AAPR;AAUI;EACI,6BAAA;AARR;AAWI;EACI,0BAAA;EACA,gBAAA;AATR;AAYI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;AAVR;AAYQ;EACI,uBAAA;AAVZ;AAaQ;EACI,oBAAA;AAXZ;AAeI;EACI,YAAA;AAbR;AAgBI;EACI,UAAA;AAdR;AAiBI;;;EAGI,cAAA;EACA,WAAA;EACA,eAAA;EAEA,YAAA;EACA,gBAAA;EACA,mBAAA;AAhBR;AAoBQ;EACI,UAAA;EACA,YAAA;AAlBZ;AAqBQ;EACI,yBAAA;EACA,UAAA;AAnBZ;AAsBQ;EACI,kBAAA;EACA,MAAA;AApBZ;AAsBY;EACI,UAAA;AApBhB;AA2BI;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AAzBR;AA4BI;EACI,qBAAA;EACA,iBAAA;EACA,YAAA;AA1BR;AA6BI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA3BR;AA8BI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA5BR;AA+BI;EACI,qBAAA;EACA,iBAAA;EACA,YAAA;AA7BR;AAgCI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,oCAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;AA9BR;AAiCI;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,oCAAA;EACA,iBAAA;EACA,UAAA;AA/BR;AAkCI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EAEA,mDAAA;AAhCR;AAmCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjCR;AAmCQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,uCAAA;AAjCZ;AAoCQ;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAlCZ;AAoCY;EACI,eAAA;AAlChB;AAqCY;EACI,cAAA;EACA,YAAA;AAnChB;AAwCI;EACI,cAAA;EACA,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;AAtCR;AAyCI;;EAEI,UAAA;EACA,kBAAA;AAvCR;AA0CI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAxCR;AA2CI;EACI,0BAAA;EACA,UAAA;AAzCR;AA4CI;EACI,SAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AA1CR;AA6CI;EACI,YAAA;AA3CR;AA8CI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA5CR;AA8CQ;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,iBAAA;AA5CZ;AA8CY;EACI,UAAA;EACA,eAAA;EACA,gBAAA;AA5ChB;AA+CY;EACI,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,SAAA;AA7ChB;AAiDQ;EACI,SAAA;AA/CZ","sourcesContent":[".upload-file.hide {\n    position: absolute;\n    top: 0;\n    opacity: 0;\n}\n\n.upload-file {\n    position: relative;\n    // width: 300px;\n    width: 100%;\n\n    .hidden {\n        display: none;\n    }\n\n    &.fixed-aspect-ratio {\n        aspect-ratio: 16/9;\n\n        .media-preview,\n        video {\n            height: 100%;\n        }\n    }\n\n    .drop-zone {\n        display: inline-block;\n        margin: auto;\n        width: 100%;\n        height: 100%;\n        min-height: 200px;\n        vertical-align: middle;\n        background: #eee;\n        color: #333;\n        position: relative;\n        border: 1px solid var(--motes-gray);\n        box-sizing: border-box;\n        overflow: hidden;\n    }\n\n    .drop-zone.file-not-empty {\n        min-height: 100px;\n    }\n\n    .drop-zone.show-placeholder {\n        background: var(--upload-background-gradient);\n    }\n\n    .drop-zone.hovering {\n        border: 1px solid var(--motes-highlight-color-dark);\n        box-sizing: border-box;\n        box-shadow: inset 0 0 100px #00000052;\n    }\n\n    .drop-zone.uploaded {\n        border: 1px solid rgb(230, 230, 230) !important;\n    }\n\n    .drop-zone a {\n        color: var(--motes-blue-link);\n    }\n\n    .drop-zone a:hover {\n        text-decoration: underline;\n        transition: none;\n    }\n\n    .drop-zone-inner {\n        text-align: center;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        pointer-events: none;\n        z-index: 1;\n\n        .file-input-button {\n            pointer-events: initial;\n        }\n\n        .file-input-button.inactive {\n            pointer-events: none;\n        }\n    }\n\n    .file-not-empty {\n        color: white;\n    }\n\n    .drop-zone-inner-hidden {\n        opacity: 0;\n    }\n\n    video,\n    img,\n    audio {\n        display: block;\n        width: 100%;\n        max-width: 100%;\n        // max-height: 70vh;\n        margin: auto;\n        margin-bottom: 0;\n        border-radius: 10px;\n    }\n\n    .media-preview {\n        img {\n            opacity: 0;\n            height: 100%;\n        }\n\n        .image-loaded {\n            transition: opacity 400ms;\n            opacity: 1;\n        }\n\n        .loading-image {\n            position: absolute;\n            top: 0;\n\n            img {\n                opacity: 1;\n            }\n        }\n    }\n\n\n\n    audio {\n        position: absolute;\n        width: 90%;\n        top: 0;\n        max-width: 400px;\n        top: 50%;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%);\n    }\n\n    .drop-zone.hovering {\n        transform: scale(1.2);\n        transition: 250ms;\n        opacity: 0.7;\n    }\n\n    .placeholder-image {\n        position: relative;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n    }\n\n    .placeholder-image img {\n        position: relative;\n        width: auto;\n        margin: auto;\n        max-height: 100%;\n        margin-top: 6px;\n    }\n\n    .drop-zone.hovering .placeholder-image {\n        transform: scale(1.2);\n        transition: 250ms;\n        opacity: 0.6;\n    }\n\n    .upload-progress {\n        position: absolute;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: inherit;\n        background-color: rgba(0, 0, 0, 0.2);\n        z-index: 2;\n        opacity: 0;\n        transition: 1200ms;\n        pointer-events: none;\n    }\n\n    .progress-overlay {\n        position: absolute;\n        width: 100%;\n        border-radius: inherit;\n        top: 0px;\n        background-color: rgba(0, 0, 0, 0.5);\n        transition: 500ms;\n        height: 0%;\n    }\n\n    .media-icon .svg-icon:hover {\n        cursor: pointer;\n        transition: none;\n        color: white;\n        -webkit-filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, .8));\n        filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, .8));\n    }\n\n    .play-icon-wrapper {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .play-button {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: none;\n            box-sizing: border-box;\n            padding: 0px;\n            border-radius: 100%;\n            background: var(--upload-background-gradient);\n            box-shadow: var(--shadow-elevation-low);\n        }\n\n        .svg-icon {\n            cursor: pointer;\n            font-size: 50px;\n            line-height: 50px;\n            transition: font-size 200ms;\n\n            &:hover {\n                font-size: 55px;\n            }\n\n            svg {\n                display: block;\n                margin: auto;\n            }\n        }\n    }\n\n    .drop-zone-error {\n        color: #dd4b39;\n        padding: 10px;\n        background-color: rgba(255, 255, 255, 0.9);\n        box-sizing: border-box;\n        transition: 200ms;\n        opacity: 0;\n        pointer-events: none;\n    }\n\n    .drop-zone-inner.shown,\n    .upload-progress.shown {\n        opacity: 1;\n        transition: 1000ms;\n    }\n\n    .audio-background-clip {\n        position: relative;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n        overflow: hidden;\n    }\n\n    .audio-background-show {\n        transition: 1000ms ease-in;\n        opacity: 1;\n    }\n\n    .audio-background {\n        top: -2px;\n        left: -2px;\n        object-fit: cover;\n        transform: scale(1.1);\n        filter: blur(6px);\n    }\n\n    .external-video {\n        height: 100%;\n    }\n\n    .placeholder-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        padding: 20px;\n        box-sizing: border-box;\n\n        .allowed-types {\n            display: flex;\n            height: 50%;\n            width: 100%;\n            margin-bottom: 20px;\n            justify-content: space-evenly;\n            opacity: 0;\n            filter: blur(6px);\n\n            &.fade-in {\n                opacity: 1;\n                filter: blur(0);\n                transition: 0.3s;\n            }\n\n            img {\n                height: 100%;\n                width: fit-content;\n                object-fit: contain;\n                margin: 0;\n            }\n        }\n\n        .drag-drop-text p {\n            margin:  0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
